import React from 'react';
import { graphql } from 'gatsby';

import { DisclaimerType } from '@/components/Disclaimer';

import BaseSimulationBlock from './BaseSimulationBlock';

type Props = {
  id: string;
  locale: 'en' | 'fr' | 'nl';
  disclaimer: DisclaimerType;
};

const KeyplanSimulationBlock: React.FC<Props> = ({
  locale,
  id,
  disclaimer,
}) => {
  return (
    <BaseSimulationBlock
      simulationType='keyplan'
      locale={locale}
      id={id}
      minHeight='260px'
      disclaimer={disclaimer}
    />
  );
};

export default KeyplanSimulationBlock;

export const keyplanSimulationBlockFragmentQuery = graphql`
  fragment KeyplanSimulationBlockFragment on ContentfulKeyplanSimulationBlock {
    id
    __typename
    disclaimer {
      ...DisclaimerFragment
    }
  }
`;
